import React from "react"

export const ToastImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="680"
      height="192"
      viewBox="0 0 680 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2720_75358)">
        <rect width="680" height="192" fill="#E6EFFE" />
        <path
          d="M589 194.5L463.5 130L433.5 172C428.217 178.633 424.868 179.327 418.5 177.5L442 194.5H589Z"
          fill="#C9B3FF"
        />
        <path
          d="M103.5 195.5L229.5 196.5L261 175L216.84 126.055L103.5 195.5Z"
          fill="white"
        />
        <path
          d="M103.5 195.5L229.5 196.5L248.5 183.5C242.971 184.322 239.952 184.553 236.5 179.5L205 134L103.5 195.5Z"
          fill="#B0C8F2"
        />
        <path
          d="M411.07 116.802L379.008 133.218C377.388 134.071 375.383 133.463 374.51 131.853C373.693 130.35 374.14 128.472 375.548 127.5L404.79 108.073"
          fill="#EEC493"
        />
        <path
          d="M411.07 116.802L379.008 133.218C377.388 134.071 375.383 133.463 374.51 131.853C373.693 130.35 374.14 128.472 375.548 127.5L404.79 108.073"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M407.827 112.21L375.341 129.166C373.721 130.016 371.718 129.408 370.843 127.801C370.024 126.297 370.474 124.418 371.884 123.448L396.999 106.12"
          fill="#EEC493"
        />
        <path
          d="M407.827 112.21L399.742 116.414L375.341 129.166C373.721 130.016 371.718 129.408 370.843 127.801C370.024 126.297 370.474 124.418 371.884 123.448L396.999 106.12"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M400.152 106.782L374.006 124.065C372.478 125.074 370.424 124.669 369.394 123.156C368.43 121.741 368.69 119.827 369.995 118.719L395.544 97.2842L400.152 106.782Z"
          fill="#EEC493"
        />
        <path
          d="M402.416 109.629C409.913 113.574 408.503 120.773 404.492 124.34C402.142 126.432 398.802 126.994 395.896 125.786L391.864 124.111L388.972 133.117L415.352 147.211L440.254 115.867L414.107 95.0824C409.343 91.2951 402.571 91.3871 397.911 95.3023L394.677 98.0253"
          fill="#EEC493"
        />
        <path
          d="M396.294 109.366L374.018 124.065C372.491 125.074 370.437 124.669 369.407 123.156C368.443 121.741 368.702 119.827 370.008 118.719L394.677 98.0215"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M403.842 109.27L373.378 116.621C371.597 117.051 369.802 115.97 369.349 114.195C368.925 112.537 369.821 110.827 371.425 110.23L403.952 97.9248L403.842 109.27Z"
          fill="#EEC493"
        />
        <path
          d="M402.416 109.629C409.913 113.574 408.503 120.773 404.492 124.34C402.142 126.432 398.802 126.994 395.896 125.786L391.864 124.111L388.972 133.117L415.352 147.211L440.254 115.867L414.107 95.0824C409.343 91.2951 402.571 91.3871 397.911 95.3023L394.677 98.0253"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M402.416 109.628L373.388 116.62C371.607 117.051 369.811 115.97 369.358 114.195C368.935 112.537 369.831 110.827 371.435 110.23L400.864 98.4486C404.344 97.0544 408.305 97.6346 411.239 99.9685L418.467 105.712"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M438.954 114.78L463 129.5L437 167L413.192 145.859L421.167 127.047L438.954 114.78Z"
          fill="#EEC493"
        />
        <path
          d="M438.954 114.78L463 129L437 167L413.192 145.859L421.167 127.047L438.954 114.78Z"
          fill="#EEC493"
        />
        <path
          d="M463 129.5L450.134 121.592L426.222 157.631L436.871 167.33"
          fill="white"
        />
        <path
          d="M463 129.5L450.134 121.592L426.222 157.631L436.871 167.33"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M413.202 160.416L419.427 151.48L436.862 167.23L432.334 173.737C430.568 176.276 427.865 178.008 424.82 178.551C421.776 179.094 418.64 178.403 416.106 176.631C410.831 172.952 409.532 165.697 413.202 160.416Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M438.954 114.78L443.216 117.377L463.16 129.531L436.862 167.242L419.427 151.493L413.192 145.859"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M416.119 176.737L455.376 202.706"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M463.147 129.502L593.5 196.5"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <ellipse
          cx="308.051"
          cy="24.6037"
          rx="12.881"
          ry="12.881"
          fill="#B99BF9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M310.894 16.0913C310.894 17.6598 309.623 22.1065 308.058 22.1065C306.493 22.1065 305.218 17.6598 305.218 16.0913C305.27 14.5613 306.525 13.3477 308.056 13.3477C309.587 13.3477 310.842 14.5613 310.894 16.0913V16.0913Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M305.212 33.1148C305.212 31.5496 306.483 27.0996 308.051 27.0996C309.62 27.0996 310.894 31.5496 310.894 33.1148C310.842 34.6449 309.587 35.8585 308.056 35.8585C306.525 35.8585 305.27 34.6449 305.218 33.1148H305.212Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M301.467 18.5104C302.893 19.1572 306.421 22.1454 305.775 23.5748C305.128 25.0043 300.555 24.3251 299.126 23.6815C297.697 23.035 297.062 21.3525 297.709 19.9236C298.356 18.4948 300.038 17.8606 301.467 18.5072V18.5104Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M314.636 30.6962C313.21 30.0494 309.678 27.0612 310.325 25.6318C310.972 24.2023 315.548 24.8815 316.974 25.5283C317.898 25.9459 318.53 26.825 318.63 27.8343C318.73 28.8437 318.285 29.8299 317.461 30.4215C316.637 31.0132 315.56 31.1203 314.636 30.7027V30.6962Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M313.785 17.7017C312.453 18.5296 309.345 21.9544 310.173 23.2868C311.001 24.6192 315.447 23.3482 316.777 22.5236C317.638 21.9892 318.149 21.0359 318.117 20.0228C318.085 19.0096 317.514 18.0906 316.621 17.6118C315.728 17.133 314.647 17.1673 313.785 17.7017Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M302.318 31.4976C303.647 30.6697 306.758 27.2449 305.93 25.9125C305.102 24.5801 300.655 25.8511 299.323 26.6757C298.046 27.5251 297.674 29.2352 298.483 30.5382C299.292 31.8412 300.99 32.266 302.318 31.4976V31.4976Z"
          stroke="white"
          strokeLinecap="round"
        />
        <circle cx="395.722" cy="50.2658" r="12.881" fill="#B99BF9" />
        <path
          d="M268.93 113.319L300.992 129.734C302.612 130.588 304.617 129.98 305.49 128.37C306.307 126.867 305.86 124.989 304.452 124.017L275.21 104.587"
          fill="#EEC493"
        />
        <path
          d="M268.93 113.319L300.992 129.734C302.612 130.588 304.617 129.98 305.49 128.37C306.307 126.867 305.86 124.989 304.452 124.017L275.21 104.587"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M272.173 108.733L304.659 125.679C306.279 126.529 308.282 125.921 309.157 124.314C309.976 122.811 309.526 120.932 308.116 119.961L283.001 102.646"
          fill="#EEC493"
        />
        <path
          d="M272.173 108.733L280.258 112.937L304.669 125.669C306.284 126.514 308.279 125.912 309.157 124.314C309.976 122.811 309.526 120.932 308.116 119.961L283.001 102.646"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M279.848 103.293L305.995 120.576C307.522 121.585 309.576 121.18 310.606 119.667C311.549 118.255 311.285 116.36 309.992 115.259L284.443 93.8242L279.848 103.293Z"
          fill="#EEC493"
        />
        <path
          d="M277.584 106.152C270.087 110.098 271.497 117.297 275.508 120.864C277.858 122.955 281.198 123.517 284.104 122.309L288.136 120.634L291.028 129.641L264.648 143.735L239.746 112.391L265.893 91.6059C270.657 87.8199 277.429 87.9118 282.089 91.8258L285.323 94.5488"
          fill="#EEC493"
        />
        <path
          d="M283.706 105.881L305.982 120.579C307.509 121.588 309.563 121.183 310.593 119.67C311.541 118.26 311.283 116.364 309.992 115.259L285.323 94.5615"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M276.158 105.793L306.622 113.144C308.402 113.574 310.198 112.493 310.651 110.719C311.075 109.06 310.179 107.35 308.575 106.754L276.048 94.4482L276.158 105.793Z"
          fill="#EEC493"
        />
        <path
          d="M277.584 106.152C270.087 110.098 271.497 117.297 275.508 120.864C277.858 122.955 281.198 123.517 284.104 122.309L288.136 120.634L291.028 129.641L264.648 143.735L239.746 112.391L265.893 91.6059C270.657 87.8199 277.429 87.9118 282.089 91.8258L285.323 94.5488"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M277.584 106.152L306.612 113.144C308.393 113.574 310.189 112.493 310.642 110.718C311.065 109.06 310.169 107.35 308.566 106.753L279.136 94.972C275.656 93.5792 271.696 94.1594 268.761 96.492L261.533 102.236"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M347.81 37.9021L340.026 46.8829C333.995 53.8369 329.471 61.9658 326.741 70.7563L320.741 90.0827C318.95 95.8468 312.826 99.0681 307.062 97.2783C301.298 95.4886 298.076 89.3654 299.866 83.6017L305.72 64.7798C308.452 55.9911 309.333 46.7314 308.307 37.5851L306.913 25.2021"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <ellipse
          cx="327.481"
          cy="31.1867"
          rx="3.85816"
          ry="21.3735"
          transform="rotate(-72.75 327.481 31.1867)"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M278.596 141.038L284.518 139.696C289.103 138.658 292.786 135.253 294.181 130.764L305.665 96.8906L307.172 97.3596L295.694 131.229C294.301 135.722 295.411 140.616 298.605 144.068L302.725 148.525L278.596 141.038Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M247.297 121.898L275.52 120.863C277.87 122.955 281.209 123.517 284.113 122.309L288.143 120.637L296.671 117.079C299.712 115.812 303.209 117.188 304.571 120.187L305.38 121.972L272.186 139.724L264.648 143.734L247.297 121.898Z"
          fill="#EEC493"
        />
        <path
          d="M275.52 120.863C277.87 122.955 281.209 123.517 284.113 122.309L288.143 120.637L296.671 117.079C299.712 115.812 303.209 117.188 304.572 120.187L305.38 121.972L272.186 139.724L264.648 143.734L247.291 121.898"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M395.476 139.562L389.655 137.405C385.15 135.733 381.764 131.652 380.768 126.7L373.097 88.5391L371.544 88.8625L379.215 127.024C380.212 131.978 378.662 137.049 375.154 140.332L370.626 144.568L395.476 139.562Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M398.558 41.7532C398.558 43.3217 397.287 47.7684 395.722 47.7684C394.157 47.7684 392.886 43.3217 392.886 41.7532C392.886 40.1868 394.155 38.917 395.722 38.917C397.288 38.917 398.558 40.1868 398.558 41.7532Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M392.886 58.777C392.886 57.2117 394.153 52.7617 395.722 52.7617C397.29 52.7617 398.558 57.2117 398.558 58.777C398.558 60.3434 397.288 61.6132 395.722 61.6132C394.155 61.6132 392.886 60.3434 392.886 58.777Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M389.137 44.1725C390.564 44.8193 394.092 47.8107 393.445 49.2369C392.798 50.6631 388.225 49.9872 386.796 49.3437C385.367 48.6971 384.733 47.0146 385.379 45.5858C386.026 44.1569 387.709 43.5227 389.137 44.1693V44.1725Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M402.306 56.358C400.88 55.7112 397.348 52.7229 397.995 51.2968C398.642 49.8706 403.218 50.5432 404.644 51.19C405.569 51.6077 406.2 52.4868 406.3 53.4961C406.401 54.5054 405.955 55.4916 405.131 56.0833C404.307 56.6749 403.231 56.7821 402.306 56.3644V56.358Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M401.446 43.3642C400.114 44.1921 397.006 47.6169 397.834 48.9493C398.662 50.2817 403.108 49.014 404.437 48.1861C405.769 47.36 406.179 45.6109 405.353 44.2794C404.527 42.9479 402.778 42.5381 401.446 43.3642Z"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M389.988 57.1665C391.32 56.3386 394.428 52.9138 393.6 51.5846C392.772 50.2554 388.326 51.5199 386.993 52.3478C386.132 52.8828 385.622 53.8363 385.655 54.8492C385.688 55.8621 386.259 56.7806 387.153 57.2585C388.046 57.7365 389.127 57.7014 389.988 57.1665Z"
          stroke="white"
          strokeLinecap="round"
        />
        <ellipse
          cx="395.874"
          cy="50.2651"
          rx="1.12543"
          ry="1.12543"
          fill="white"
        />
        <path
          d="M393.319 53.0273L373.802 87.6764C373.459 88.2747 372.874 88.6959 372.198 88.8316C371.522 88.9673 370.821 88.8044 370.273 88.3847L338.283 63.8742"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <ellipse
          cx="365.879"
          cy="57.4166"
          rx="28.3428"
          ry="6.07345"
          transform="rotate(-11.36 365.879 57.4166)"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M241.046 111.304L217 126L243 164L266.808 142.386L258.833 123.574L241.046 111.304Z"
          fill="#EEC493"
        />
        <path
          d="M376.961 72.0429L362.237 70.8172L354.876 76.3377L355.003 76.6837L370.274 88.3843C370.821 88.804 371.522 88.9669 372.198 88.8312C372.875 88.6955 373.459 88.2744 373.802 87.6761L385.768 66.5225L376.961 72.0429Z"
          fill="#2B5FCE"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M354.919 76.2376C353.887 75.5095 353.367 74.2522 353.582 73.008C353.798 71.7637 354.711 70.7549 355.928 70.4164C359.976 69.291 364.866 68.476 366.6 68.6927L371.312 69.2522C375.346 69.7299 379.418 68.7491 382.792 66.4871L389.024 60.6045L384.092 69.7308C381.764 73.7922 377.103 75.9139 372.511 75.0023L366.949 73.8962C365.597 73.628 364.203 73.66 362.864 73.99L355.048 76.4382C354.993 76.4679 354.924 76.4504 354.89 76.3978C354.856 76.3453 354.869 76.2755 354.919 76.2376Z"
          fill="#1947AA"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M308.41 51.3584C307.976 55.9129 307.074 60.4104 305.716 64.7795L299.873 83.6014C298.083 89.3651 301.305 95.4883 307.068 97.278C312.833 99.0678 318.957 95.8464 320.748 90.0823L326.741 70.7559C327.103 69.5917 327.496 68.4404 327.921 67.302L325.447 61.4097L308.41 51.3584Z"
          fill="#2B5FCE"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M327.271 69.1451C327.271 69.1451 329.929 61.6131 325.635 58.751C321.34 55.8889 318.054 56.0668 315.609 51.7979C311.521 44.6443 308.549 50.6208 308.249 52.6161C307.227 59.3655 310.089 62.2276 315.405 63.0458C320.722 63.864 326.246 63.3854 327.271 69.1451Z"
          fill="#1947AA"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M320.919 60.6045L327.064 11.8617C327.309 9.95963 326.28 8.12139 324.532 7.33408L311.117 1.29297"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M372.385 72.2143L382.042 30.6574C382.554 28.4562 384.281 26.7422 386.486 26.2462L391.058 25.2178"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M330.544 81.6543L325.842 103.736L340.766 87.9929L351.4 100.874L349.97 83.2907L358.557 86.3565"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M344.243 27.8761L351.4 8.04199L354.876 31.5564L372.256 29.92L360.601 41.9861L368.986 45.0519"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M337.086 14.1768L338.315 26.854"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M266.798 156.942L260.573 148.017L243.138 163.769L247.666 170.279C249.432 172.818 252.136 174.549 255.18 175.092C258.225 175.634 261.36 174.943 263.894 173.171C266.435 171.406 268.169 168.704 268.713 165.659C269.258 162.615 268.569 159.478 266.798 156.942Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M263.881 173.261L224.624 199.23"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M432.703 125.375L404.48 124.34C402.13 126.432 398.791 126.993 395.887 125.786L391.857 124.11L383.329 120.553C380.287 119.286 376.788 120.665 375.428 123.667L374.62 125.453L407.814 143.201L415.352 147.211L432.703 125.375Z"
          fill="#EEC493"
        />
        <path
          d="M404.48 124.34C402.13 126.432 398.791 126.993 395.887 125.786L391.857 124.11L383.329 120.553C380.287 119.286 376.788 120.665 375.428 123.667L374.62 125.453L407.814 143.201L415.352 147.211"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <ellipse
          cx="453.843"
          cy="131.342"
          rx="2.86209"
          ry="2.86208"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M204.547 133.211L236.347 179.823C239.386 184.273 245.435 185.46 249.93 182.487L252.947 180.492"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M241.046 111.304L236.784 113.901L216.84 126.054L243.138 163.766L260.573 148.016L266.808 142.386"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
        <path
          d="M216.853 126.024L101 196.999"
          stroke="#1D2B47"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2720_75358">
          <rect width="680" height="192" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
